module.exports = __webpack_public_path__ + "static/media/Logo_Naratama.4a9b2c01.PNG";